import { render, staticRenderFns } from "./Handlers.vue?vue&type=template&id=339607cd&scoped=true&"
import script from "./Handlers.vue?vue&type=script&lang=js&"
export * from "./Handlers.vue?vue&type=script&lang=js&"
import style0 from "./Handlers.vue?vue&type=style&index=0&id=339607cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339607cd",
  null
  
)

export default component.exports